var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRisk1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17417_6413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 38.911V171.108C33.9985 172.205 34.2134 173.291 34.6326 174.304C35.0518 175.317 35.667 176.238 36.443 177.014C37.219 177.789 38.1407 178.405 39.1551 178.825C40.1696 179.245 41.2571 179.461 42.3553 179.461H131.844C134.063 179.461 136.192 178.581 137.761 177.014C139.33 175.448 140.211 173.324 140.211 171.108V50.7501C140.207 49.3176 139.634 47.9453 138.618 46.9333L124.114 32.4554C123.617 31.9542 123.025 31.5565 122.373 31.2855C121.721 31.0146 121.021 30.8757 120.314 30.8769L42.4261 30.5588C41.3224 30.551 40.228 30.7613 39.2061 31.1776C38.1841 31.5938 37.2547 32.2078 36.4715 32.9842C35.6883 33.7605 35.0667 34.6839 34.6425 35.7011C34.2183 36.7183 34 37.8092 34 38.911Z",
    fill: "#DEE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 60.0603V66.0059M34 78.6108V171.108C33.9985 172.205 34.2134 173.291 34.6326 174.304C35.0518 175.317 35.667 176.238 36.443 177.014C37.219 177.789 38.1407 178.405 39.1551 178.825C40.1696 179.245 41.2571 179.461 42.3553 179.461H68.0581M34 52.212V38.911C34 37.8092 34.2183 36.7183 34.6425 35.7011C35.0667 34.6839 35.6883 33.7605 36.4715 32.9842C37.2547 32.2078 38.1841 31.5938 39.2061 31.1776C40.228 30.7613 41.3224 30.551 42.4261 30.5588L120.314 30.8769C121.021 30.8757 121.721 31.0146 122.373 31.2855C123.025 31.5565 123.617 31.9542 124.114 32.4554L138.618 46.9333C139.634 47.9453 140.207 49.3176 140.211 50.7501V171.108C140.211 173.324 139.33 175.448 137.761 177.014C136.192 178.581 134.063 179.461 131.844 179.461C131.844 179.461 108.192 179.461 94.9936 179.461M80.6772 179.461H87.8201",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5596 20.3524V152.55C52.558 153.646 52.773 154.732 53.1922 155.745C53.6114 156.758 54.2266 157.679 55.0026 158.455C55.7786 159.231 56.7002 159.846 57.7147 160.266C58.7292 160.686 59.8167 160.902 60.9149 160.902H150.404C152.623 160.902 154.751 160.022 156.32 158.456C157.889 156.889 158.771 154.765 158.771 152.55V32.1915C158.766 30.759 158.193 29.3867 157.178 28.3747L142.674 13.8968C142.177 13.3956 141.585 12.9979 140.933 12.7269C140.28 12.456 139.581 12.3171 138.874 12.3183L60.9857 12.0002C59.882 11.9924 58.7876 12.2027 57.7656 12.619C56.7437 13.0352 55.8143 13.6492 55.031 14.4256C54.2478 15.2019 53.6262 16.1253 53.2021 17.1425C52.7779 18.1597 52.5596 19.2506 52.5596 20.3524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5596 41.5017V47.4473M52.5596 60.0522V152.55C52.558 153.646 52.773 154.732 53.1922 155.745C53.6114 156.758 54.2266 157.679 55.0026 158.455C55.7786 159.231 56.7002 159.846 57.7147 160.266C58.7292 160.686 59.8167 160.902 60.9149 160.902H86.6177M52.5596 33.6534V20.3524C52.5596 19.2506 52.7779 18.1597 53.2021 17.1425C53.6262 16.1253 54.2478 15.2019 55.031 14.4256C55.8143 13.6492 56.7437 13.0352 57.7656 12.619C58.7876 12.2027 59.882 11.9924 60.9857 12.0002L138.874 12.3183C139.581 12.3171 140.28 12.456 140.933 12.7269C141.585 12.9979 142.177 13.3956 142.674 13.8968L157.178 28.3747C158.193 29.3867 158.766 30.759 158.771 32.1915V152.55C158.771 154.765 157.889 156.889 156.32 158.456C154.751 160.022 152.623 160.902 150.404 160.902C150.404 160.902 126.752 160.902 113.553 160.902M99.2368 160.902H106.38",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.273 19.7871L135.272 32.4151C135.272 32.4151 135.272 33.2098 136.024 34.0799C136.775 34.9501 137.69 35.123 137.69 35.123L148.844 35.1231",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.041 44.7949H148.964",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2598 76.332H148.964",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2598 86.9102H109.713M141.105 86.9102H115.665",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2598 114.746H148.964",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0449 134.633H148.964",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2598 124.689H141.105",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.041 54.6074H141.104",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0188 27.1965L67.7598 53.5842C67.4358 54.1419 67.2651 54.775 67.2646 55.4196C67.2642 56.0643 67.4342 56.6976 67.7575 57.2557C68.0807 57.8138 68.5457 58.2768 69.1056 58.5981C69.6654 58.9194 70.3003 59.0876 70.9461 59.0856H101.464C102.109 59.0855 102.742 58.9158 103.301 58.5937C103.859 58.2715 104.322 57.8083 104.644 57.2506C104.966 56.6928 105.135 56.0603 105.134 55.4167C105.133 54.7731 104.962 54.141 104.639 53.5842L89.3797 27.1965C89.0554 26.6417 88.5911 26.1813 88.0331 25.8614C87.4751 25.5414 86.8428 25.373 86.1992 25.373C85.5557 25.373 84.9234 25.5414 84.3654 25.8614C83.8074 26.1813 83.3431 26.6417 83.0188 27.1965Z",
    fill: "#7EF2F3",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5089 73.3984H70.1561C68.3181 73.3984 66.8281 74.8858 66.8281 76.7205V88.053C66.8281 89.8877 68.3181 91.375 70.1561 91.375H81.5089C83.3469 91.375 84.8368 89.8877 84.8368 88.053V76.7205C84.8368 74.8858 83.3469 73.3984 81.5089 73.3984Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4853 109.693H70.1797C68.3287 109.693 66.8281 111.191 66.8281 113.039V124.324C66.8281 126.172 68.3287 127.67 70.1797 127.67H81.4853C83.3363 127.67 84.8368 126.172 84.8368 124.324V113.039C84.8368 111.191 83.3363 109.693 81.4853 109.693Z",
    fill: "#DEE2E5",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2051 31.5664V47.399",
    stroke: "#334B5D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2049 56.1631C87.5019 56.1631 88.5533 55.1136 88.5533 53.8189C88.5533 52.5242 87.5019 51.4746 86.2049 51.4746C84.9079 51.4746 83.8564 52.5242 83.8564 53.8189C83.8564 55.1136 84.9079 56.1631 86.2049 56.1631Z",
    fill: "#334B5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17417_6413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk1);
export default __webpack_public_path__ + "static/media/risk1.20fb1e595f5de180c9757212ebb0c712.svg";
export { ForwardRef as ReactComponent };